module.exports = __webpack_public_path__ + "260ef443edb4dfd026d82e2b21a4c75c.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/octicons/octicons/octicons.woff
 ** module id = 395
 ** module chunks = 0
 **/